import RotateRightIcon from '@/assets/icons/icon-rotate-right.svg'
import { Tooltip } from '@/components/ui/tooltip'
import PauseIcon from '@/modules/chatting/icons/pause.svg'
import PlayIcon from '@/modules/chatting/icons/play.svg'

interface PlayPauseActionButtonProps {
  isPlaying: boolean
  isAudioDownloading?: boolean
  onPlay: React.MouseEventHandler<SVGElement>
  onPause: React.MouseEventHandler<SVGElement>
  iconClassName?: string
  className?: string
}

export const AudioPlayPauseButton = ({
  isPlaying,
  isAudioDownloading,
  onPlay,
  onPause,
  iconClassName,
  className,
}: PlayPauseActionButtonProps) => {
  const handleClickPlay: React.MouseEventHandler<SVGElement> = (event) => {
    event.preventDefault()
    onPlay(event)
  }

  const handleClickPause: React.MouseEventHandler<SVGElement> = (event) => {
    event.preventDefault()
    onPause(event)
  }

  return (
    <Tooltip
      content={isPlaying ? 'Pause' : 'Play'}
      className={className}
      contentClassName="w-max min-w-0 px-3"
    >
      {isAudioDownloading ? (
        <RotateRightIcon className="h-5 w-5 animate-spin" />
      ) : isPlaying ? (
        <PauseIcon
          onClick={handleClickPause}
          className={iconClassName}
        />
      ) : (
        <PlayIcon
          onClick={handleClickPlay}
          className={iconClassName}
        />
      )}
    </Tooltip>
  )
}
